import { isEmpty } from './validators'

export const toNumberOrUndefined = (value, convertor = Number, validator = Number.isNaN) => {
  if (isEmpty(value) || typeof value !== 'string' && typeof value !== 'number') {
    return undefined
  }

  const number = convertor(value)

  if (validator(number)) {
    return undefined
  }

  return number
}

export const toIntegerOrUndefined = value => {
  return toNumberOrUndefined(value, parseInt, isNaN)
}
export const toFloatOrUndefined = value => {
  return toNumberOrUndefined(value, parseFloat, isNaN)
}
